import 'react-day-picker/style.css';
import { Alert } from '@ahmdigital/ui';
import { DateRange, DayPicker } from 'react-day-picker';
import { useFormikContext } from 'formik';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { FIELD_NAMES } from '../../../../constants';
import { FormValues } from '../../types';
import { StyledClickable, StyledDayPickerWrapper, StyledHeading } from './styles';
import constants from '../../../../../../../../ahm-constants';
import device from '../../../../../../../../utils/device';
import useTravelWidgetContext from '../../hooks/use-travel-widget-context';

const TWELVE_MONTHS = 12;
const ONE_MONTH = 1;
const TWO_MONTH = 2;

const DatePicker = () => {
  const { selected, setSelected } = useTravelWidgetContext();
  const { setFieldValue, values } = useFormikContext<FormValues>();
  const { departureDate, returnDate } = values;
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (departureDate || returnDate) {
      const parsedDepartureDate = departureDate
        ? moment(departureDate, constants.DATE_FORMAT.STANDARD).toDate()
        : undefined;
      const parsedReturnDate = returnDate ? moment(returnDate, constants.DATE_FORMAT.STANDARD).toDate() : undefined;

      setSelected({
        from: parsedDepartureDate,
        to: parsedReturnDate,
      });
    }
  }, []);

  useEffect(() => {
    const currentDatePlusTwo = moment().add(2, 'days');
    const momentDepartureDate = moment(departureDate, constants.DATE_FORMAT.STANDARD);
    if (!momentDepartureDate.isValid()) {
      setShowWarning(false);
      return;
    }
    const isDateWithin3Days = momentDepartureDate.isSameOrBefore(currentDatePlusTwo, 'day');
    setShowWarning(isDateWithin3Days);
  }, [departureDate, returnDate]);

  const monthsToDisplay = device.isMobile() ? ONE_MONTH : TWO_MONTH;
  const startDate = new Date();
  const endDate = new Date().setMonth(startDate.getMonth() + TWELVE_MONTHS);

  const setSelectedDates = (dates: DateRange) => {
    setSelected(dates);
    setFieldValue(
      FIELD_NAMES.DEPARTURE_DATE,
      dates.from ? moment(dates.from).format(constants.DATE_FORMAT.STANDARD) : null,
    );
    setFieldValue(FIELD_NAMES.RETURN_DATE, dates.to ? moment(dates.to).format(constants.DATE_FORMAT.STANDARD) : null);
  };

  const clearDates = () => {
    setSelected({ from: undefined, to: undefined });
    setFieldValue(FIELD_NAMES.DEPARTURE_DATE, '');
    setFieldValue(FIELD_NAMES.RETURN_DATE, '');
  };

  return (
    <StyledDayPickerWrapper>
      {showWarning && (
        <Alert heading="Already on your trip?" level="warning">
          If you’ve already left home and are on your trip, this cover is subject to a 3-day no-cover period.
        </Alert>
      )}
      <StyledHeading looksLike="h5">What dates are you traveling?</StyledHeading>
      <DayPicker
        defaultMonth={startDate}
        disabled={{ before: startDate }}
        onSelect={setSelectedDates}
        selected={selected}
        min={ONE_MONTH}
        mode="range"
        numberOfMonths={monthsToDisplay}
        required
        startMonth={startDate}
        endMonth={new Date(endDate)}
      />
      <StyledClickable onClick={clearDates}>Clear dates</StyledClickable>
    </StyledDayPickerWrapper>
  );
};

export default DatePicker;
